import { memoizeDeep, safeMerge } from "../common/utilities";
import { visuallyHidden } from "../themes/common/styles";
const setTheme = memoizeDeep(function (_ref) {
  let {
    radiobutton,
    labelLocation,
    labelHidden
  } = _ref;
  let cssRoot = {},
      cssBody = {},
      cssInput = {},
      cssLabel = {},
      cssLabelText = {};

  if (radiobutton) {
    cssRoot = radiobutton.root;
    cssBody = radiobutton.body;
    cssInput = radiobutton.input;
    cssLabel = radiobutton.label;
    cssLabelText = radiobutton.labelText;
    cssRoot = safeMerge(cssRoot, radiobutton.modifiers.labelLocation[labelLocation].root);
    cssInput = safeMerge(cssInput, radiobutton.modifiers.labelLocation[labelLocation].input);
    cssLabel = safeMerge(cssLabel, radiobutton.modifiers.labelLocation[labelLocation].label);
    cssLabelText = safeMerge(cssLabelText, radiobutton.modifiers.labelLocation[labelLocation].labelText);

    if (labelHidden) {
      cssLabelText = safeMerge(cssLabelText, visuallyHidden);
    }
  }

  return {
    cssRoot,
    cssBody,
    cssInput,
    cssLabel,
    cssLabelText
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    labelLocation,
    labelHidden
  } = _ref2;
  const radiobutton = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.radiobutton;
  return setTheme({
    radiobutton,
    labelLocation,
    labelHidden
  });
}